import React from 'react';

import Header from './Header';
import Footer from './Footer';
import Search from './Search';

const PageWrapper = ({ children }) => (
  <div className="u-outer-page-wrapper">
    <Header />
    <div className="u-page-wrapper">
      <Search extraClasses="mb4 mb5-ns" />
      {children}
    </div>
    <Footer>
      <span className="db di-ns">Møre og Romsdal Fotograflaug 2017</span>
      <span className="dn di-ns"> | </span>
      <span className="db di-ns">ragnarha@gmail.com, tlf 90 84 58 61 </span>
      <span className="dn di-ns"> | </span>
      <span className="db di-ns">
        Utvikling frå{' '}
        <a className="light-blue" href="https://appucci.no">
          appucci.no
        </a>
      </span>
    </Footer>
  </div>
);

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js